import { NgModule } from '@angular/core';
import { MatInputModule } from '@angular/material/input';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { GoogleChartsModule } from 'angular-google-charts';
import { AngularSplitModule } from 'angular-split';
import { FileUploaderModule } from '../file-uploader/file-uploader.module';
import { MapOpenlayersModule } from '../map-openlayers/map-openlayers.module';
import { SharedModule } from '../shared/shared.module';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { ChartTabComponent } from './chart-tab/chart-tab.component';
import { FehmarnComponent } from './fehmarn/fehmarn.component';
import { LoadChainageDropdownComponent } from './load-chainage/load-chainage-dropdown/load-chainage-dropdown.component';
import { LoadChainageListComponent } from './load-chainage/load-chainage-list/load-chainage-list.component';
import { LoadChainageComponent } from './load-chainage/load-chainage/load-chainage.component';
import { LogMessageComponent } from './log-messages/log-message/log-message.component';
import { LogMessagesListComponent } from './log-messages/log-messages-list/log-messages-list.component';
import { PartnersComponent } from './partners/partners.component';
import { DialogRasterComponent } from './raster/dialog-raster/dialog-raster.component';
import { RasterCategoriesListComponent } from './raster/raster-categories-list/raster-categories-list.component';
import { RasterCategoryDropdownComponent } from './raster/raster-category-dropdown/raster-category-dropdown.component';
import { RasterCategoryComponent } from './raster/raster-category/raster-category.component';
import { RasterDepthComponent } from './raster/raster-depth/raster-depth.component';
import { RasterComponent } from './raster/raster/raster.component';
import { RastersListComponent } from './raster/rasters-list/rasters-list.component';
import { TypeOfRasterDropdownComponent } from './raster/type-of-raster-dropdown/type-of-raster-dropdown.component';
import { SdtPositionListComponent } from './sdt-position/sdt-position-list/sdt-position-list.component';
import { SdtPositionComponent } from './sdt-position/sdt-position/sdt-position.component';
import { DialogRecalucateQueueComponent } from './sections/dialog-recalucate-queue/dialog-recalucate-queue.component';
import { GravelCalcTypeDropdownComponent } from './sections/gravel-calc-type-dropdown/gravel-calc-type-dropdown.component';
import { RecalculateQueueComponent } from './sections/recalculate-queue/recalculate-queue.component';
import { TunnelSectionsDashboardComponent } from './sections/tunnel-sections-dashboard/tunnel-sections-dashboard.component';
import { TunnelSectionsListComponent } from './sections/tunnel-sections-list/tunnel-sections-list.component';
import { TunnelSectionsComponent } from './sections/tunnel-sections/tunnel-sections.component';
import { DialogStressAreaComponent } from './stress-area/dialog-stress-area/dialog-stress-area.component';
import { StressAreaComponent } from './stress-area/stress-area/stress-area.component';
import { DialogStressGroupComponent } from './stress-group/dialog-stress-group/dialog-stress-group.component';
import { StressGroupComponent } from './stress-group/stress-group/stress-group.component';
import { SystemParamComponent } from './system-param/system-param/system-param.component';
import { SystemParamsListComponent } from './system-param/system-params-list/system-params-list.component';
import { ProfileDropdownComponent } from './users/profile-dropdown/profile-dropdown.component';
import { UserComponent } from './users/user/user.component';
import { UsersListComponent } from './users/users-list/users-list.component';

@NgModule({
  declarations: [
    TunnelSectionsListComponent,
    FehmarnComponent,
    PartnersComponent,
    ChartTabComponent,
    UserComponent,
    UsersListComponent,
    ChangePasswordComponent,
    RasterCategoryDropdownComponent,
    RastersListComponent,
    SystemParamsListComponent,
    SystemParamComponent,
    RasterCategoryComponent,
    RasterComponent,
    RasterCategoriesListComponent,
    TunnelSectionsDashboardComponent,
    TunnelSectionsComponent,
    LoadChainageComponent,
    LoadChainageListComponent,
    LoadChainageDropdownComponent,
    TypeOfRasterDropdownComponent,
    LogMessageComponent,
    LogMessagesListComponent,
    StressAreaComponent,
    DialogStressAreaComponent,
    ProfileDropdownComponent,
    DialogRasterComponent,
    RasterDepthComponent,
    RecalculateQueueComponent,
    DialogRecalucateQueueComponent,
    DialogStressGroupComponent,
    StressGroupComponent,
    GravelCalcTypeDropdownComponent,
    SdtPositionComponent,
    SdtPositionListComponent
    ],
  imports: [
    SharedModule,
    FileUploaderModule,
    AngularSplitModule,
    MatTabsModule,
    MatTableModule,
    MapOpenlayersModule,
    MatInputModule,
    GoogleChartsModule.forRoot({ version: '51' }),

  ]
})
export class FlcModule { }
